"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { useSite } from "@/contexts/site/site.context";
import { useTracking } from "@/hooks/tracking/use-tracking";
import { useCurrentUrl } from "@/hooks/use-current-url.hook";
import { RegularButton } from "../Button/RegularButton/RegularButton.component";
import { CardBody } from "../Card/_components/CardBody/CardBody.component";
import { Card } from "../Card/Card.component";
import { Translation } from "../Translation/Translation.component";
import { mapToTrialUpgradeModel } from "./mappers/map-to-trial-upgrade-model";
import { TrialUpgradeProgressBar } from "./TrialUpgradeProgressBar.component";
type TrialUpgradePromptProps = {
  readonly className?: string;
  readonly remainingTrialDays?: number | null;
};
export function TrialUpgrade(t0) {
  const $ = _c(26);
  const {
    className,
    remainingTrialDays: t1
  } = t0;
  const remainingTrialDays = t1 === undefined ? null : t1;
  const {
    emit
  } = useTracking();
  const {
    absolute: currentUrl
  } = useCurrentUrl();
  const {
    locale,
    subscription: t2
  } = useSite();
  const {
    trialDays
  } = t2;
  let t3;
  if ($[0] !== remainingTrialDays || $[1] !== trialDays) {
    t3 = mapToTrialUpgradeModel(trialDays, remainingTrialDays);
    $[0] = remainingTrialDays;
    $[1] = trialDays;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    trialPeriod,
    variant
  } = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      da: "Bliv abonnent",
      de: "Abonnent werden",
      en: "Become a subscriber",
      no: "Bli abonnent",
      sv: "Bli prenumerant"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const becomeSubscriberLabel = t4[locale];
  let t5;
  if ($[4] !== currentUrl || $[5] !== emit) {
    t5 = () => {
      emit({
        event: "button-click",
        model: {
          position: "art-upgr-a",
          toUrl: "/shop",
          url: currentUrl
        }
      });
    };
    $[4] = currentUrl;
    $[5] = emit;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleClick = t5;
  let t6;
  if ($[7] !== className) {
    t6 = clsx(className, "not-prose relative py-4 transition-all lg:hover:scale-101");
    $[7] = className;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== trialPeriod || $[10] !== variant) {
    t7 = trialPeriod !== null ? <TrialUpgradeProgressBar progressPercentage={trialPeriod.progressPercentage} remainingDays={trialPeriod.remainingDays} variant={variant} /> : null;
    $[9] = trialPeriod;
    $[10] = variant;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== trialPeriod) {
    t8 = <h2 className="font-heading font-theme-bold text-2xl">{trialPeriod === null ? <Translation model={{
        da: "Din pr\xF8veadgang udl\xF8ber snart",
        de: "Ihr Testzugang l\xE4uft bald ab",
        en: "Your trial access expires soon",
        no: "Din pr\xF8vetilgang utl\xF8per snart",
        sv: "Din testperiod l\xF6per ut snart"
      }} /> : trialPeriod.remainingDays > 1 ? <Translation model={{
        da: `Din prøveadgang udløber om ${trialPeriod.remainingDays} dage`,
        de: `Ihr Testzugang läuft in ${trialPeriod.remainingDays} Tagen ab`,
        en: `Your trial access expires in ${trialPeriod.remainingDays} days`,
        no: `Din prøvetilgang utløper om ${trialPeriod.remainingDays} dager`,
        sv: `Din testperiod löper ut om ${trialPeriod.remainingDays} dagar`
      }} /> : <Translation model={{
        da: "Din pr\xF8veadgang udl\xF8ber i dag",
        de: "Ihr Testzugang l\xE4uft heute ab",
        en: "Your trial access expires today",
        no: "Din pr\xF8vetilgang utl\xF8per i dag",
        sv: "Din testperiod l\xF6per ut idag"
      }} />}</h2>;
    $[12] = trialPeriod;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="mx-auto max-w-sm"><Translation model={{
        da: "Bliv abonnent i dag \u2013 s\xE5 undg\xE5r du at miste dit faglige overblik.",
        de: "Werden Sie noch heute Abonnent \u2013 damit Sie Ihren fachlichen \xDCberblick nicht verlieren.",
        en: "Become a subscriber today \u2013 so you don't miss your professional overview.",
        no: "Bli abonnent i dag \u2013 s\xE5 unng\xE5r du \xE5 miste din faglige oversikt.",
        sv: "Bli prenumerant idag \u2013 s\xE5 slipper du att f\xF6rlora din professionella \xF6verblick."
      }} /></p>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8) {
    t10 = <div className="flex flex-col items-center gap-2 text-center">{t8}{t9}</div>;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <RegularButton className="no-underline shadow-lg" testId="buy-btn" variant="highlight"><Translation model={{
        da: "Bliv abonnent",
        de: "Abonnent werden",
        en: "Become a subscriber",
        no: "Bli abonnent",
        sv: "Bli prenumerant"
      }} /></RegularButton>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t7) {
    t12 = <CardBody className="flex flex-col gap-4">{t7}{t10}{t11}</CardBody>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== becomeSubscriberLabel || $[22] !== handleClick || $[23] !== t12 || $[24] !== t6) {
    t13 = <Card ariaLabel={becomeSubscriberLabel} className={t6} elevated={true} href="/shop" onClick={handleClick} position="art-upgr-a" role="complementary">{t12}</Card>;
    $[21] = becomeSubscriberLabel;
    $[22] = handleClick;
    $[23] = t12;
    $[24] = t6;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}